import { platform } from '../../device/platform'
import { IMicrofront, MinimalVersion } from '../../../interfaces/MFE/IMicrofront'
import { getMainModulesUrl } from './main-modules-url'
import getScreenType from '../../device'
import { filesystem } from '..'
import GeolocationManager from '../../geolocation/GeolocationManager'
import packageJson from '../../../../../package.json'
import { EventTracker } from '../../event-tracker'
import { tenant } from '../../tenant'

export function initGlobalVariables ({
  microfronts,
  memoryModules
}: {
  microfronts: IMicrofront[]
  memoryModules: MinimalVersion[]
}): void {
  window.TENANT = tenant
  window.mainUrls = getMainModulesUrl({ discovered: microfronts, downloaded: memoryModules })
  window.APP_VERSION = packageJson.version
  window.AURA_MODULES_CONFIG = {}
  window.MODULES_STATIC_CONFIG = {
    // APIMANAGER: {
    //   sessionInfo: initialToken ?? '',
    //   _baseUrl: new Tenant().getAPIBaseURL(),
    //   FILESYSTEM: filesystem
    // },
    FILESYSTEM: filesystem,
    SCREEN_TYPE: getScreenType(),
    GEOLOCATION: GeolocationManager.getInstance(),
    PLATFORM: platform,
    EVENTS: {
      REDUX_STORE_CHANGE_EVENT: 'ARCHITECTURE_REDUX_STORE_CHANGED_EVENT',
      HANDLERS_CHANGE_EVENT: 'ARCHITECTURE_HANDLERS_CHANGED_EVENT',
      MAP_CHANGE_EVENT: 'ARCHITECTURE_MAP_CHANGED_EVENT',
      PLUGINS_GEOLOCATION_POSITION_CHANGE_EVENT: 'PLUGINS_GEOLOCATION_POSITION_CHANGED_EVENT',
      CORE_STATE_CHANGE_EVENT: 'CORE_STATE_UPDATED_EVENT'
    },
    EVENT_TRACKER: EventTracker.getInstance()
  }
}
